import { render, staticRenderFns } from "./journeySelector.vue?vue&type=template&id=70deb35e"
import script from "./journeySelector.vue?vue&type=script&lang=js"
export * from "./journeySelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports